import React from 'react';
import { MenuItem, Select, SelectProps, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import FormInputErrorMessage from './form-input-error-message';

type Option = {
  label: string | React.ReactNode;
  value: string;
  isDisabled?: boolean;
};

type Props = Omit<SelectProps, 'variant'> & {
  label?: string;
  errorMessage?: string;
  options: Option[];
  includeNullOption?: boolean;
  helperText?: string | null;
};

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    maxWidth: '100%',
    marginTop: '10px',
  },
  nullOption: {
    height: '36px',
  },
  helperText: {
    marginLeft: '5px',
    fontSize: '10px',
  },
}));

const FormSelectField = ({
  label,
  errorMessage,
  options,
  includeNullOption,
  helperText,
  value,
  ...other
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.input}>
      {label && <Typography variant="caption">{label}</Typography>}
      <Select
        key={String(value)}
        error={!!errorMessage}
        fullWidth
        variant="outlined"
        SelectDisplayProps={{
          style: {
            height: '30px',
            paddingRight: '40px',
            padding: '1vh 2vh',
          },
        }}
        {...other}
        value={value}
      >
        {includeNullOption && <MenuItem className={classes.nullOption} value={null as any} />}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} disabled={Boolean(option.isDisabled)}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {errorMessage && <FormInputErrorMessage error={errorMessage} />}
      {helperText && <Typography className={classes.helperText}>{helperText}</Typography>}
    </div>
  );
};

export default FormSelectField;
